import ProjectResource from "../../Root/resource/id";

export default class HistoryResource {
    static menu = {
        데이터_수정_이력: "데이터 수정 이력",
        이벤트_탐지_이력: "이벤트 탐지 이력",
        이벤트_탐지_분석: "이벤트 탐지 분석",
        SOP_이력: "SOP 이력",
        상황전파_이력: "상황전파 이력",
        상세보기: "상세보기",
        안전구역_평가_이력: "안전구역 평가 이력",
        이벤트_이력: "이벤트 이력",
        고장_이력: "고장 이력",
        점검_이력: "점검 이력",
        보고서: "보고서",
        통계: "통계",
    }

    static AssessmentClass = {
        A: "A",
        B: "B",
        C: "C",
        D: "D",
        E: "E"
    }
}